const getDestinationPickerUrlParams = searchWidgetData => {
  const {
    source,
    destination,
    journeyType,
    anyTime,
    isAnywhere,
    travelDate,
    tripDuration,
    passengers,
    flightClass
  } = searchWidgetData;

  const isDestinationACity = destination.t === 'city' ? true : false;
  const isDestinationAnAirport = destination.t === 'airport' ? true : false;
  const isDestinationACountry = destination.t === 'country' ? true : false;
  const isDestinationAContinent = destination.t === 'continent' ? true : false;

  return `tripType=${journeyType.toUpperCase()}&from=${source.iata}&${`to${
    isAnywhere
      ? '=ANYWHERE'
      : isDestinationACity || isDestinationAnAirport
      ? `=${destination.iata ? destination.iata : destination.g[0].iata}`
      : isDestinationACountry
      ? `Country=${destination?.cc}`
      : destination.t === 'continent'
      ? `Continent=${destination.coc}`
      : `Country=${destination.code}`
  }`}${`&labelFrom=${source.ct}&labelTo=${
    isAnywhere
      ? 'ANYWHERE'
      : isDestinationACity
      ? `${destination.ct}`
      : isDestinationACountry
      ? `${destination.cnty}`
      : isDestinationAContinent
      ? `${destination.con}`
      : `${destination.ct}`
  }`}&month=${anyTime ? 'ANYTIME' : `${travelDate.yyyymm}`}${
    journeyType === 'rt' ? `&duration=${tripDuration}` : ''
  }&passengers=${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}`;
};

export default getDestinationPickerUrlParams;
